export default __webpack_public_path__ + "media/images/icons/party-bb94788418da3c6421bdbdcc25aa2da8.png";